export default __webpack_public_path__ + "static/pkwebsite-d93e24098ab95d609f133d95529949f4.png";